import type { TelegramSellerSocialLinksResponseDto } from '@/generated';

export type SocialLinkItem = { href: string; label: string };

export function buildSocialLinkItems(links: TelegramSellerSocialLinksResponseDto): SocialLinkItem[] {
  const items: SocialLinkItem[] = [];

  if (links.telegramUsername) {
    items.push({
      href: `https://t.me/${links.telegramUsername}`,
      label: 'Telegram',
    });
  }
  if (links.instagramUrl) {
    items.push({ href: links.instagramUrl, label: 'Instagram' });
  }
  if (links.websiteUrl) {
    items.push({ href: links.websiteUrl, label: 'Сайт' });
  }
  if (links.facebookUrl) {
    items.push({ href: links.facebookUrl, label: 'Facebook' });
  }
  if (links.tiktokUrl) {
    items.push({ href: links.tiktokUrl, label: 'TikTok' });
  }
  if (links.youtubeUrl) {
    items.push({ href: links.youtubeUrl, label: 'YouTube' });
  }
  if (links.linkedInUrl) {
    items.push({ href: links.linkedInUrl, label: 'LinkedIn' });
  }

  return items;
}
